export default __webpack_public_path__ + "static/media/Green_Player_Podium_min.d8117e3c.png";